import script from "./CommonSearchNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonSearchNew.vue?vue&type=script&lang=ts&setup=true"

import "./CommonSearchNew.vue?vue&type=style&index=0&id=0f35b4fc&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f35b4fc"]])

export default __exports__